import Vue from 'vue'
import {default as VCA, ref} from '@vue/composition-api'
import bus from '~/bus'
import {useBusUtils} from '~/commons/busUtils'
import isEqual from 'lodash/isEqual'
import mappedEvents from '~/events/all'
import Api from '~/store/idonia-api/api'
import {useBackEvents} from '~/commons/events'
import cache from '~/commons/cache'
Vue.use(VCA)

const currentFile = ref(null)
const children = ref(null)
const ancestors = ref(null)
let childrenEndpoint = ''
let promiseResolve
function makePromise () {
  return new Promise(function (resolve, reject) {
    promiseResolve = resolve
  })
}
let promises = [makePromise()]
const relevantChannels = ref(null)
const {replaceHandler, setHandlerAsPromise} = useBusUtils()
export function useEventWatcher () {
  let accountID = ''

  replaceHandler(bus, 'loadedAccountUUID', (id) => {
    accountID = id
  })

  function setListeners (route) {
    children.value = null
    currentFile.value = null
    ancestors.value = null
    promises = [makePromise()]
    relevantChannels.value = []

    switch (route.name) {
      case 'myspace':
        addChannel('myspace/account/' + accountID)
        childrenEndpoint = 'files'
        let stopMy = setHandlerAsPromise(bus, 'files/loadedElements', (c) => {
          if (c) {
            children.value = c.map((child) => child.file_uuid)
          }
          currentFile.value = 'myspace'
        })
        promises.push(stopMy)
        promiseResolve()
        return promises
      case 'mysearch':
        addChannel('myspace/account/' + accountID)
        childrenEndpoint = 'file/full-search'
        let stopSearch = setHandlerAsPromise(bus, 'file/full-search/loadedElements', (c) => {
          if (c) {
            children.value = c.map((child) => child.file_uuid)
          }
          currentFile.value = 'myspace'
        })
        promises.push(stopSearch)
        promiseResolve()
        return promises
      case 'shared':
        addChannel('shared/account/' + accountID)
        childrenEndpoint = 'files/sharers'
        let stopShared = setHandlerAsPromise(bus, 'files/sharers/loadedElements', (shared) => {
          if (shared) {
            children.value = shared.map(
              (child) => child.account_id ? 'account/' + child.account_id : child.group_id ? 'group/' + child.group_id : 'organization/' + child.organization_id)
          }
          currentFile.value = 'shared'
        })
        promises.push(stopShared)
        promiseResolve()
        return promises
      case 'sharer-files':
        let stopSharer = setHandlerAsPromise(bus, 'sharer/loadedAccount', (sharer) => {
          addChannel('sharer/' + sharer.type + '/' + sharer.account_uuid)
          currentFile.value = sharer.type + '/' + sharer.account_uuid
        })
        if (route.params.id) {
          childrenEndpoint = 'files/account/' + route.params.id
          let stopSharerChildren = setHandlerAsPromise(bus, 'files/account/' + route.params.id + '/loadedElements', (sharer) => {
            if (sharer) {
              children.value = sharer.map((child) => child.file_uuid)
            }
          })
          promises.push(stopSharerChildren)
        }
        promises.push(stopSharer)
        promiseResolve()
        return promises
      case 'trash':
        addChannel('trash/account/' + accountID)
        childrenEndpoint = 'files/deleted'
        let stopTrash = setHandlerAsPromise(bus, 'files/deleted/loadedElements', (deleted) => {
          if (deleted) {
            children.value = deleted.map((child) => child.file_uuid)
          }
          currentFile.value = 'trash'
        })
        promises.push(stopTrash)
        promiseResolve()
        return promises
      case 'recents':
        addChannel('recent/account/' + accountID)
        childrenEndpoint = 'files/recent'
        let stopRecent = setHandlerAsPromise(bus, 'files/recent/loadedElements', (recent) => {
          if (recent) {
            children.value = recent.map((child) => child.file_uuid)
          }
          currentFile.value = 'recent'
        })
        promises.push(stopRecent)
        promiseResolve()
        return promises
      case 'starred':
        addChannel('starred/account/' + accountID)
        childrenEndpoint = 'files/favorite'
        let stopStarred = setHandlerAsPromise(bus, 'files/favorite/loadedElements', (favorite) => {
          if (favorite) {
            children.value = favorite.map((child) => child.file_uuid)
          }
          currentFile.value = 'starred'
        })
        promises.push(stopStarred)
        promiseResolve()
        return promises
      default:
        let stopFile = setHandlerAsPromise(bus, 'file/loadedElements', (record) => {
          if (record && record.file_uuid) {
            addChannel('file/' + record.file_uuid)
            currentFile.value = record.file_uuid
          }
        })
        let stopFileAncestor = setHandlerAsPromise(bus, 'navPathLoaded', (ancest) => {
          ancestors.value = ancest.map((ancestor) => {
            addChannel('file/' + ancestor.file_uuid)
            return ancestor.file_uuid
          })
        })
        promises.push(stopFileAncestor)
        if (route.params.id) {
          childrenEndpoint = 'directory/' + route.params.id + '/children'
          let stopChildren = setHandlerAsPromise(bus, 'directory/' + route.params.id + '/children/loadedElements', (c) => {
            if (c) {
              children.value = c.map((child) => child.file_uuid)
            }
          })
          let stopViewer = setHandlerAsPromise(bus, 'viewer/previewLoaded', () => {})
          promises.push(Promise.race([stopChildren, stopViewer]))
        }
        promises.push(stopFile)
    }
    promiseResolve()
    return promises
  }

  function addChannel (channel) {
    relevantChannels.value.push(channel)
  }

  function startEventWatch (route) {
    promises = setListeners(route)
  }
  return {
    startEventWatch
  }
}

export function getEventFile (fileID, event = '') {
  const file = cache.get(fileID + event)
  if (file) {
    file._fromCache = true
    return Promise.resolve(file)
  }
  cache.set(fileID + event,
    Api.getV2('file/' + fileID).then((response) => {
      return response.body
    }), 2)
  return cache.get(fileID + event)
}

const {subscribe} = useBackEvents()
export function useEventHelper () {
  function actorIsSharer (actor) {
    let owner = actor.split('/')
    let t = owner[0]
    let id = owner[1]
    return Api.getV2('files/sharers').then((response) => {
      let index = response && response.body && response.body.results
        ? response.body.results.findIndex((e) => {
          switch (t) {
            case 'account':
              return e.account_uuid === id
            case 'group':
              return e.group_id === id
            case 'organization':
              return e.organization_id === id
          }
        })
        : -1
      return index !== -1
    }).catch(() => {
      return false
    })
  }

  const defaultEvents = {
    created: 'created',
    copied: 'copied',
    moved: 'moved',
    starred: 'starred',
    edited: 'edited',
    shared: 'shared',
    unshared: 'unshared',
    trashed: 'trashed',
    restored: 'restored',
    deleted: 'deleted',
    transferred: 'transferred',
    commented: 'commented'
  }

  const events = Object.assign(defaultEvents, {
    documentCompleted: 'document_completed',
    videoCompleted: 'video_completed'
  })

  function newHandler (handler, context) {
    let cacheKey = Symbol('event handler cache key')
    return function (payload) {
      if (isEqual(cache.get(cacheKey), payload)) {
        return
      }
      handler.bind(context)(payload)
      cache.set(cacheKey, payload)
    }
  }

  function updateSubscriptionsOnUpdate (context, handlers, bhm) {
    bhm.addHandler(bus, 'pageElementsLoaded', (p) => {
      if (p.endpoint === childrenEndpoint) {
        if (p.page === 1) {
          context.fileChildren = p.elements.map((child) => child.file_uuid)
        } else {
          context.fileChildren.push(...p.elements.map((child) => child.file_uuid))
        }
      }
    })
    bhm.addHandler(bus, 'navPathLoaded', (ancest) => {
      let newChannels = []
      context.fileAncestors = ancest.map((ancestor) => {
        newChannels.push('file/' + ancestor.file_uuid)
        return ancestor.file_uuid
      })
      for (const [event, handler] of handlers.entries()) {
        subscribe(event, newChannels, handler)
      }
    })
  }

  function getEventContext () {
    let context = {}
    return Promise.all(promises).then(() => {
      context.file = currentFile.value
      context.fileChildren = children.value
      context.channels = relevantChannels.value
      context.fileAncestors = ancestors.value
      return context
    })
  }

  function subscribeToEventsDefaultHandlers (context) {
    const eventHandlers = new Map()
    for (let event in defaultEvents) {
      if (mappedEvents.hasOwnProperty(defaultEvents[event])) {
        let handler = newHandler(mappedEvents[defaultEvents[event]].do, context)
        subscribe(defaultEvents[event], context.channels, handler)
        eventHandlers.set(defaultEvents[event], handler)
      }
    }
    const completeHandler = newHandler(mappedEvents['completed'].do, context)
    subscribe([events.documentCompleted], context.channels, completeHandler)
    eventHandlers.set(events.documentCompleted, completeHandler)
    return eventHandlers
  }
  return {
    events,
    getEventContext,
    getEventFile,
    newHandler,
    actorIsSharer,
    subscribeToEventsDefaultHandlers,
    updateSubscriptionsOnUpdate,
    defaultHandlers: mappedEvents
  }
}



// WEBPACK FOOTER //
// ./src/helpers/eventHelper.js